import React, { useState, useEffect } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import axios from 'axios';
import Classes from './AllClassesSessions';
import Pending from './AllPending';

import './AllClasses.css';

const AllClasses = ({ userData  }) => {
  const [currentTab, setCurrentTab] = useState('classes');
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDay, setSelectedDay] = useState('today');
  const [counts, setCounts] = useState({ pendingFeedbacks: 0, nbOfEvaluations: 0, nbofapprove: 0, nbofdemo: 0, nbofpaid: 0 });
  const [loadingCounts, setLoadingCounts] = useState(true);
  const [isLoading, setIsLoading] = useState(true); // Add loading state
 
  
  // Fetch pending feedback and evaluation counts
  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const formattedDay = (() => {
          const today = new Date();
          const lowercaseDay = selectedDay.toLowerCase();
  
          if (lowercaseDay === 'today') {
            today.setHours(today.getHours() + 2);
            return today.toISOString().split('T')[0];
          } else if (lowercaseDay === 'tomorrow') {
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);
            tomorrow.setHours(today.getHours() + 2);
            return tomorrow.toISOString().split('T')[0];
          } else if (lowercaseDay === 'yesterday') {
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);
            yesterday.setHours(today.getHours() + 2);
            return yesterday.toISOString().split('T')[0];
          } else {
            return selectedDay;
          }
        })();
  
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/myclasses/${formattedDay}`
       ,        { headers: { 'Authorization': `Bearer ${localStorage.getItem('userData')}` } }
 );
        setCounts(response.data);
      } catch (error) {
        console.error('Error fetching counts:', error);
      } finally {
        setLoadingCounts(false);
        setIsLoading(false);
      }
    };
  
    if (userData?.id) {
      fetchCounts();
  
      const intervalId = setInterval(() => {
        fetchCounts();
      }, 60000);
  
      return () => clearInterval(intervalId);
    } else {
      setIsLoading(true);
    }
  }, [userData?.id, selectedDay]); // ✅ Correct dependency array
  

  // Update current time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Format date display
  const formattedDate = currentDate.toLocaleDateString('en-US', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });

  const formattedTime = currentDate.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });
  const handleSubmitrefresh = async () => {
    try {
      const formattedDay = (() => {
        const today = new Date();
        const lowercaseDay = selectedDay.toLowerCase();

        if (lowercaseDay === 'today') {
          today.setHours(today.getHours() + 2);
          return today.toISOString().split('T')[0];
        } else if (lowercaseDay === 'tomorrow') {
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1);
          tomorrow.setHours(today.getHours() + 2);
          return tomorrow.toISOString().split('T')[0];
        } else if (lowercaseDay === 'yesterday') {
          const yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);
          yesterday.setHours(today.getHours() + 2);
          return yesterday.toISOString().split('T')[0];
        } else {
          return selectedDay;
        }
      })();

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/myclasses/${formattedDay}`
      ,        { headers: { 'Authorization': `Bearer ${localStorage.getItem('userData')}` } }
);
      console.log(response.data);

      setCounts(response.data);
    } catch (error) {
      console.error('Error fetching counts:', error);
    } finally {
      setLoadingCounts(false);
      setIsLoading(false); // Data is loaded
    }
  };
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.replace(/_/g, ' ');

  const handleDayChange = (day) => {
    setSelectedDay(day);
    
  };

  // Show loading state while waiting for userData

  if (isLoading || !userData) {
    return (
      <div className="teacher-dashboard">
        <div className="teacher-dashboard__loading-container">
          <div className="teacher-dashboard__loading-spinner"></div>
          <p>Loading your Classes...</p>
        </div>
      </div>
    );
  }
  return (
    <div className="my-classes">
      {/* Header Section */}
      <header className="my-classes__header">
        <div className="my-classes__header-content">
          <h1>
            Welcome back, <span>{userData.fullName}</span>
          </h1>
          <p className="my-classes__subheader">This is your classes for {formattedDate}</p>
        </div>
        
      </header>

      {/* Current Date/Time Bar */}
      <div className="my-classes__datetime-bar">
        <div className="my-classes__datetime-content">
          <span>Your current date and time:</span>
          <span className="my-classes__datetime">
            {formattedDate} {formattedTime} {timezone}
          </span>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="my-classes__tabs-container">
        <div className="my-classes__tabs">
          <button
            className={`my-classes__tab ${currentTab === 'classes' ? 'active' : ''}`}
            onClick={() => setCurrentTab('classes')}
          >
            My Classes
            {counts.nbofpaid > 0 && (
              <span className="my-classes__notification-badge1">
                {loadingCounts ? '...' : counts.nbofpaid}
              </span>
            )}
            {counts.nbofdemo > 0 && (
              <span className="my-classes__notification-badge">
                {loadingCounts ? '...' : counts.nbofdemo}
              </span>
            )}
            {currentTab === 'classes' && <div className="my-classes__tab-indicator"></div>}
          </button>
          
          <button
            className={`my-classes__tab ${currentTab === 'pending' ? 'active' : ''}`}
            onClick={() => setCurrentTab('pending')}
          >
            Pending Feedback
            {counts.pendingFeedbacks > 0 && (
              <span className="my-classes__notification-badge">
                {loadingCounts ? '...' : counts.pendingFeedbacks}
              </span>
            )}
            {currentTab === 'pending' && <div className="my-classes__tab-indicator"></div>}
          </button>
          
          <button
            className={`my-classes__tab ${currentTab === 'evaluation' ? 'active' : ''}`}
            onClick={() => setCurrentTab('evaluation')}
          >
            Evaluation
            {counts.nbOfEvaluations > 0 && (
              <span className="my-classes__notification-badge">
                {loadingCounts ? '...' : counts.nbOfEvaluations}
              </span>
            )}
            {currentTab === 'evaluation' && <div className="my-classes__tab-indicator"></div>}
          </button>
          
          <button
            className={`my-classes__tab ${currentTab === 'feedbackapprove' ? 'active' : ''}`}
            onClick={() => setCurrentTab('feedbackapprove')}
          >
            Feedback Approve
            {counts.nbofapprove > 0 && (
              <span className="my-classes__notification-badge">
                {loadingCounts ? '...' : counts.nbofapprove}
              </span>
            )}
            {currentTab === 'feedbackapprove' && <div className="my-classes__tab-indicator"></div>}
          </button>
          {/* Day Selector Dropdown */}
          <div className="my-classes__day-selector">
            <div className="my-classes__day-dropdown">
              <select
                value={selectedDay}
                onChange={(e) => handleDayChange(e.target.value)}
              >
                <option value="yesterday">Yesterday</option>
                <option value="today">Today</option>
                <option value="tomorrow">Tomorrow</option>
              </select>
              <FiChevronDown className="my-classes__dropdown-icon" />
            </div>
          </div>
        </div>
      </div>

      {/* Content Section - Now safely rendered after userData is loaded */}
      <div className="my-classes__content">
        {currentTab === 'classes' && <Classes userData={userData} day={selectedDay} />}
        {currentTab === 'pending' && <Pending onSubmitrefresh={handleSubmitrefresh} userData={userData}  />}

      </div>
    </div>
  );
};

export default AllClasses;